import css from './song.module.scss';
import {SongProps} from './song.types';

const setPlayedState = (played?: SongProps['played']): JSX.Element | undefined => {
	/**
     * @desc: The exact value of true and false should be checked since
	  undefined is used for hiding icon and false is used for returning icon 
     */
	if (played === true) {
		return <img className={css.playedState} data-testid="yes-icon" src="/img/yes-icon.svg" />;
	} else if (played === false) {
		return <img className={css.playedState} data-testid="no-icon" src="/img/no-icon.svg" />;
	} else {
		return undefined;
	}
};

export const Song = (props: SongProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.index}>{props.index}</div>
			<div className={css.image}>
				<img src={props.image} />
			</div>
			<div className={css.details}>
				<div className={css.albumContainer}>
					<div className={css.album}>
						{props.album}
						{setPlayedState(props.played)}
					</div>
				</div>
				<span className={css.songName}>{props.songName}</span>
			</div>
		</div>
	);
};
